export { default as List } from 'notifications_historic/containers/NotificationsHistoricListContainer';
export { default as Form } from 'notifications_historic/containers/NotificationsHistoricFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/containers/index.js